import { apiClient } from '@/lib/apiClient';

/** One ignore-list entry (mirrors IgnoredSenderListItem on the API). */
export interface IgnoredSender {
  id: string;
  pattern: string;
  note: string | null;
}

/** IT-Admin-only management of the inbound ignore-list (403 otherwise). */
export const ignoredSendersApi = {
  list: (getAccessToken: () => Promise<string>, signal?: AbortSignal): Promise<IgnoredSender[]> =>
    apiClient.get<IgnoredSender[]>('/api/ignored-senders', { getAccessToken, signal }),

  create: (
    pattern: string,
    note: string | null,
    getAccessToken: () => Promise<string>
  ): Promise<IgnoredSender> =>
    apiClient.post<IgnoredSender>('/api/ignored-senders', { pattern, note }, { getAccessToken }),

  remove: (id: string, getAccessToken: () => Promise<string>): Promise<void> =>
    apiClient.del<void>(`/api/ignored-senders/${id}`, { getAccessToken })
};
